import { render, staticRenderFns } from "./tagKeyword.vue?vue&type=template&id=65082c98"
import script from "./tagKeyword.vue?vue&type=script&lang=js"
export * from "./tagKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports